let getToken: () => Promise<string | undefined>;

export const token = {
  getToken: () => getToken?.(),
  setTokenGetter: (func: () => Promise<string | undefined>) =>
    (getToken = func),
};
